module.exports = __webpack_public_path__ + "static/media/topright.baab6ebb.svg";